function ProofSection({ image }) {
  return (
    <section className="section proof-section reveal" id="proof">
      <div className="proof-head">
        <span className="section-kicker">Chinatao</span>
        <h2>Комплексное сопровождение бизнеса с Китаем</h2>
      </div>

      <div className="proof-content">
        <div className="proof-image">
          <img
            src={image}
            alt="Chinatao: Китай, визы и сопровождение"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="proof-copy">
          <p>
            Полный спектр услуг по Китаю CHINATAO — ваш надежный партнер по работе с Китаем.
          </p>

          <ul className="proof-services">
            <li>Оформление виз и организация поездок</li>
            <li>Туры, выставки и бизнес-маршруты</li>
            <li>Консалтинг по деловым поездкам</li>
            <li>Поиск партнеров и производителей</li>
            <li>Переговоры с заводами и фабриками</li>
            <li>Сопровождение поездок и контроль этапов</li>
          </ul>

          <p className="proof-final">
            Работаем быстро, профессионально и на результат.
          </p>

          <div className="proof-list">
            <span>Одна заявка</span>
            <span>Ответственный менеджер</span>
            <span>Прозрачные этапы</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProofSection;